module.exports = __webpack_public_path__ + "static/media/stjerne_grey-min.dcfea202.png";